import { lazy, Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout/Layout'
import PageMeta from './components/common/PageMeta'
import { OfflineSync } from './components/common/OfflineSync'

const Home = lazy(() => import('./pages/Home'))
const Services = lazy(() => import('./pages/Services'))
const Trainers = lazy(() => import('./pages/Trainers'))
const TrainerProfile = lazy(() => import('./pages/TrainerProfile'))
const Book = lazy(() => import('./pages/Book'))
const About = lazy(() => import('./pages/About'))
const Contact = lazy(() => import('./pages/Contact'))
const Login = lazy(() => import('./pages/Login'))
const Signup = lazy(() => import('./pages/Signup'))
const Admin = lazy(() => import('./pages/Admin'))
const Account = lazy(() => import('./pages/Account'))
const CheckoutSuccess = lazy(() => import('./pages/CheckoutSuccess'))
const Schedule = lazy(() => import('./pages/Schedule'))
const Videos = lazy(() => import('./pages/Videos'))
const Live = lazy(() => import('./pages/Live'))
const Nutrition = lazy(() => import('./pages/Nutrition'))
const Community = lazy(() => import('./pages/Community'))

function PageLoader() {
  return (
    <div className="page-loader" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
      <div className="spinner" style={{ width: 48, height: 48, border: '4px solid var(--gray-200)', borderTopColor: 'var(--primary)', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
    </div>
  )
}

function App() {
  return (
    <>
      <OfflineSync />
    <Layout>
      <Routes>
        <Route path="/" element={<Suspense fallback={<PageLoader />}><Home /></Suspense>} />
        <Route path="/services" element={<Suspense fallback={<PageLoader />}><Services /></Suspense>} />
        <Route path="/trainers" element={<Suspense fallback={<PageLoader />}><Trainers /></Suspense>} />
        <Route path="/trainers/:id" element={<Suspense fallback={<PageLoader />}><TrainerProfile /></Suspense>} />
        <Route path="/book" element={<Suspense fallback={<PageLoader />}><Book /></Suspense>} />
        <Route path="/book/:trainerId" element={<Suspense fallback={<PageLoader />}><Book /></Suspense>} />
        <Route path="/about" element={<Suspense fallback={<PageLoader />}><About /></Suspense>} />
        <Route path="/contact" element={<Suspense fallback={<PageLoader />}><Contact /></Suspense>} />
        <Route path="/login" element={<Suspense fallback={<PageLoader />}><Login /></Suspense>} />
        <Route path="/signup" element={<Suspense fallback={<PageLoader />}><Signup /></Suspense>} />
        <Route path="/admin" element={<Suspense fallback={<PageLoader />}><Admin /></Suspense>} />
        <Route path="/account" element={<Suspense fallback={<PageLoader />}><Account /></Suspense>} />
        <Route path="/checkout/success" element={<Suspense fallback={<PageLoader />}><CheckoutSuccess /></Suspense>} />
        <Route path="/schedule" element={<Suspense fallback={<PageLoader />}><Schedule /></Suspense>} />
        <Route path="/videos" element={<Suspense fallback={<PageLoader />}><Videos /></Suspense>} />
        <Route path="/live" element={<Suspense fallback={<PageLoader />}><Live /></Suspense>} />
        <Route path="/nutrition" element={<Suspense fallback={<PageLoader />}><Nutrition /></Suspense>} />
        <Route path="/community" element={<Suspense fallback={<PageLoader />}><Community /></Suspense>} />
      </Routes>
    </Layout>
    </>
  )
}

export default App
